import { render, staticRenderFns } from "./socio-form.vue?vue&type=template&id=d5102b06&scoped=true&lang=html&"
import script from "./socio-form.vue?vue&type=script&lang=js&"
export * from "./socio-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5102b06",
  null
  
)

export default component.exports